import Vue from 'vue';
import App from './App.vue';
import store from './store';
import router from './router';
import Buefy from 'buefy';
import './registerServiceWorker';
import './assets/perso.scss';
import '@mdi/font/css/materialdesignicons.css';
import axios from 'axios';

Vue.use(Buefy, {
   defaultToastDuration: 3200
});

Vue.config.productionTip = false;

// gérer les 401 unauthenticated
axios.interceptors.response.use(
   function(response) {
      return response;
   },
   function(error) {
      if (401 === error.response.status) {
         router.push({
            name: 'logout',
            params: {
               message: 'Votre session a expirée. Veuillez vous reconnecter.'
            }
         });
      } else {
         return Promise.reject(error);
      }
   }
);

new Vue({
   store,
   router,
   render: h => h(App)
}).$mount('#app');
